import React from "react";
import { AutoFocusAlgorithmProperty } from "../../../Model/CaptureProfile";
import "./AutoFocusRangeOptions.css";
import DefaultImagingSettingTextBox from "./DefaultImagingSettingTextBox";

const AUTO_FOCUS_Z_MAX = "autoFocusZmax";
const AUTO_FOCUS_Z_MIN = "autoFocusZmin";

type Props = {
  style: React.CSSProperties;
  autoFocusAlgorithmProperty: AutoFocusAlgorithmProperty;
  onChange: (autoFocusAlgorithmProperty: AutoFocusAlgorithmProperty) => void;
  onErrorOccur: (key: string) => void;
  onErrorCleared: (key: string) => void;
};

export default function AutoFocusRangeOptions({ style, autoFocusAlgorithmProperty, onChange, onErrorOccur, onErrorCleared }: Props) {
  return (
    <div
      className="auto-focus-range"
      style={{
        ...style,
      }}
    >
      <DefaultImagingSettingTextBox
        value={autoFocusAlgorithmProperty.autoFocusZmin}
        onChange={(name, value) => onChange({ ...autoFocusAlgorithmProperty, autoFocusZmin: value })}
        label="Auto Focus Start Z"
        name={AUTO_FOCUS_Z_MIN}
        unit="mm"
        style={{
          gridArea: AUTO_FOCUS_Z_MIN,
        }}
        disabled={false}
        isInteger={false}
        min={-50}
        max={50}
        onErrorOccur={(name) => onErrorOccur(name)}
        onErrorCleared={(name) => onErrorCleared(name)}
      />

      <DefaultImagingSettingTextBox
        value={autoFocusAlgorithmProperty.autoFocusZmax}
        onChange={(name, value) => onChange({ ...autoFocusAlgorithmProperty, autoFocusZmax: value })}
        label="Auto Focus Stop Z"
        name={AUTO_FOCUS_Z_MAX}
        unit="mm"
        style={{
          gridArea: AUTO_FOCUS_Z_MAX,
        }}
        disabled={false}
        isInteger={false}
        min={-50}
        max={50}
        onErrorOccur={(name) => onErrorOccur(name)}
        onErrorCleared={(name) => onErrorCleared(name)}
      />
    </div>
  );
}
